<template>
    <div class="select-disease-box">
        <div class="base-button" @click="onEdit" v-if="isEdit">选择</div>
        <div class="disease-box">
            <div class="disease-item" :class="item.key === selectDiseaseType ? 'disease-item-active' : ''"
                v-for="(item, index) in selectedDiseaseList" :key="index">
                {{ item.value }}
            </div>
        </div>
        <van-popup v-model="show" position="bottom" :style="{ height: '100%' }" closeable>
            <div class="disease-popup">
                <div class="popup-title">
                    本次问诊病种选择
                </div>
                <div class="popup-info van-hairline--top-bottom">
                    <div>已选病种：<span class="select-length">{{ popupSubDiseaseTypesList.length }}</span>
                    </div>
                    <div class="disease-box">
                        <div class="popup-info-title">主诉病种：{{ popupDiseaseType === null ? '-' : '' }}</div>
                        <div class="disease-item disease-item-active popup-info-item" v-if="popupDiseaseType !== null">{{
                            diseaseMap[popupDiseaseType].value
                        }}</div>
                    </div>
                </div>
                <div class="popup-content">
                    <div class="popup-content-left van-hairline--right">
                        <div class="left-item" v-for="(item, index) in diseaseList.filter((row) => row.key !== 0)" :key="index"
                            :class="popupSubDiseaseTypesList.includes(item.key) ? 'left-item-disabled' : ''"
                            @click="onPopupSelect(item)">
                            {{ item.value }}
                        </div>
                    </div>
                    <div class="popup-content-right">
                        <div>再次点击已选病种标签，设为主诉病种</div>
                        <div class="disease-box">
                            <div class="disease-item" v-for="item in popupSelectedDiseaseList" :key="item.key"
                                :class="item.key === popupDiseaseType ? 'disease-item-active' : ''"
                                @click="onPopupSelectDiseaseType(item)">
                                {{ item.value }}
                                <van-icon name="cross" class="close-box" @click.stop="onPopupRemove(item)" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="popup-bottom">
                    <van-button @click="onCancel" native-type="button" class="button-box">取消</van-button>
                    <van-button type="info" @click="onConfirm" native-type="button" class="button-box"
                        :disabled="!(typeof popupDiseaseType === 'number')">确定</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: 'selectDisease',
    props: {
        diseaseType: {
            type: Number,
        },
        diseaseTypeList: {
            type: String,
            default: ''
        },
        isEdit:{
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            show: false,
            popupDiseaseType: null,
            popupSubDiseaseTypesList: [],
        }
    },
    computed: {
        ...mapGetters({
            diseaseList: 'getDiseaseType'
        }),
        diseaseMap() {
            const map = {}
            this.diseaseList.forEach(item => {
                map[item.key] = item
            })
            return map
        },
        selectDiseaseType: {
            get() {
                return this.diseaseType
            },
            set(value) {
                this.$emit("update:diseaseType", value);
            }
        },
        selectSubDiseaseTypes: {
            get() {
                return this.diseaseTypeList
            },
            set(value) {
                this.$emit("update:diseaseTypeList", value);
            }
        },
        selectedDiseaseList() {
            if (typeof this.selectDiseaseType === 'number') {
                return this.diseaseList.filter(item => ([this.selectDiseaseType, ...(this.selectSubDiseaseTypes || '').split(',').map(Number)].includes(item.key)))
            } else {
                return []
            }

        },
        popupSelectedDiseaseList() {
            return this.diseaseList.filter(item => (this.popupSubDiseaseTypesList.includes(item.key)))
        },
    },
    methods: {
        onEdit() {
            this.popupDiseaseType = this.selectDiseaseType
            this.popupSubDiseaseTypesList = typeof this.selectDiseaseType === 'number' ? this.selectSubDiseaseTypes.split(',').map(Number) : []
            this.show = true
        },
        onCancel() {
            this.show = false
        },
        onConfirm() {
            this.selectDiseaseType = this.popupDiseaseType
            this.selectSubDiseaseTypes = this.popupSubDiseaseTypesList.join(',')
            this.show = false
        },
        onPopupSelect(item) {
            if (this.popupSubDiseaseTypesList.includes(item.key)) return
            if (item.value === '综合咨询' || this.popupSubDiseaseTypesList.length === 1 && this.diseaseMap[this.popupSubDiseaseTypesList[0]].value === '综合咨询') {
                this.popupSubDiseaseTypesList = [item.key]
                this.popupDiseaseType = null
            }
            this.popupSubDiseaseTypesList = [...new Set([...this.popupSubDiseaseTypesList, item.key])]
        },
        onPopupSelectDiseaseType(item) {
            this.popupDiseaseType = this.popupDiseaseType === item.key ? null : item.key
        },
        onPopupRemove(item) {
            this.popupSubDiseaseTypesList = this.popupSubDiseaseTypesList.filter(it => it !== item.key)
            if (this.popupDiseaseType === item.key || this.popupSubDiseaseTypesList.length === 0) {
                this.popupDiseaseType = null
            }
        }

    },
}
</script>
<style lang="scss" scoped>
.select-disease-box {
    line-height: normal;
    width: 100%;
    position: relative;

    .base-button {
        position: absolute;
        top: -28px;
        right: 0;
        background: #0082ef;
        border-radius: 4px;
        padding: 5px 18px;
        color: #fff;
        cursor: pointer;

    }

    .disease-box {
        display: flex;
        flex-wrap: wrap;


        .disease-item {
            padding: 4px 9px;
            background: #eff3fb;
            border: 1px solid #0082ef;
            color: #0082ef;
            border-radius: 4px;
            margin-right: 10px;
            margin-top: 10px;

            .close-box {
                cursor: pointer;
                padding: 0px 5px 0 0;
            }
        }

        .disease-item-active {
            background: #efffdf;
            border: 1px solid #5ec326;
            color: #5ec326;
        }
    }
}

.disease-popup {
    height: 100%;
    display: flex;
    flex-direction: column;

    .popup-title {
        padding: 25px 15px;
        font-size: 19px;
        color: #333;
        font-weight: bold;
    }

    .popup-info {
        padding: 25px 15px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .popup-info-length {
            color: #0082ef;
            font-weight: bold;
        }

        .popup-info-title {
            display: flex;
            align-items: center;
        }

        .popup-info-item {
            margin: 0;
        }
    }

    .popup-content {
        flex: 1;
        overflow: hidden;
        display: flex;
        width: 100%;

        .popup-content-left {
            height: 100%;
            overflow-y: auto;
            width: 120px;

            .left-item {
                padding: 10px 0;
                text-align: center;
                cursor: pointer;
                margin-top: 5px;
                background: #f5f5f5;

                &:not(.left-item-disabled):hover {
                    background: #eff3fb;
                    color: #0082ef;
                }
            }

            .left-item-disabled {
                background: #eff3fb;
                color: #a8abb2;
                cursor: not-allowed;
            }

        }

        .popup-content-right {
            height: 100%;
            overflow-y: auto;
            padding: 10px;
            flex: 1;
        }
    }

    .popup-bottom {
        height: 84px;
        background: #ffffff;
        box-sizing: border-box;
        padding: 16px 25px;
        display: flex;

        .button-box {
            font-size: 18px;
            border: none;
            border-radius: 8px;
            flex: 1.5;

            &:nth-child(1) {
                flex: 1;
                background: #e6f0fa;
                margin-right: 30px;
                color: #1989fa;
            }
        }
    }
}
</style>